import { ThemeProvider } from "../../contexts/ThemeContext";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import HowItWorks from "./components/HowItWorks";
import Benefits from "./components/Benefits";
import IndustriesServed from "./components/IndustriesServed";
import DeploymentProcess from "./components/DeploymentProcess";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <ThemeProvider>
      <div
        style={{
          fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Arial, sans-serif",
          WebkitFontSmoothing: "antialiased",
          MozOsxFontSmoothing: "grayscale",
        }}
      >
        <Navbar />
        <main>
          <HeroSection />
          <HowItWorks />
          <Benefits />
          <IndustriesServed />
          <DeploymentProcess />
          <ContactSection />
        </main>
        <Footer />
      </div>
    </ThemeProvider>
  );
}
